import pricingSaga from "./subSagas/pricingSaga";
import towerPricingSaga from "./subSagas/towerPricingSaga";
import { spawn } from "redux-saga/effects";

export default function* rootSaga() {
  yield spawn(pricingSaga);
  yield spawn(towerPricingSaga);
}
